exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".config-push-green{color:#80c269}.config-push-grey{color:#999}.config-push .search-tool-stage .search-time-wrap>.search-btn,.config-push .search-tool-stage .search-time-wrap>div,.config-push .search-tool-stage>.search-btn,.config-push .search-tool-stage>div,.config-push .tool-stage>.tab-stage.recent-date{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/configPush/common.scss
// module id = 532
// module chunks = 2